export default "__VITE_ASSET__CNYVgmdi__"